import { render, staticRenderFns } from "./CycleAnvaOnlineIframeSitecore.vue?vue&type=template&id=a0c54368"
import script from "./CycleAnvaOnlineIframeSitecore.vue?vue&type=script&lang=js"
export * from "./CycleAnvaOnlineIframeSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports